import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

/* ================= STYLES ================= */

const BlogDetailsWrapper = styled.section`
  width: 100%;
  padding: 100px 0;
  background-color: #000;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
`;

const BlogTitle = styled.h1`
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 20px;
  background: linear-gradient(45deg, #ff6b35, #4a90e2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Meta = styled.div`
  color: #999;
  font-size: 0.85rem;
  margin-bottom: 30px;
`;

const FeaturedImage = styled.div`
  width: 100%;
  height: 420px;
  border-radius: 20px;
  margin-bottom: 40px;
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    height: 260px;
  }
`;

const Content = styled.div`
  color: #ddd;
  font-size: 1rem;
  line-height: 1.8;

  p {
    margin-bottom: 20px;
  }

  h2, h3, h4 {
    color: #fff;
    margin: 40px 0 15px;
  }

  img {
    max-width: 100%;
    border-radius: 12px;
    margin: 20px 0;
  }

  a {
    color: #ff6b35;
    text-decoration: underline;
  }
`;

/* ================= COMPONENT ================= */

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    axios
      .get(
        `https://blogs.zyntro.in/wp-json/wp/v2/posts?slug=${slug}&_embed`
      )
      .then(res => {
        setBlog(res.data[0]);
      })
      .catch(err => console.error(err));
  }, [slug]);

  if (!blog) return null;

  const featuredImage =
    blog._embedded?.['wp:featuredmedia']?.[0]?.source_url;

  return (
    <BlogDetailsWrapper>
      <Container>
        <BlogTitle
          dangerouslySetInnerHTML={{ __html: blog.title.rendered }}
        />

        <Meta>
          {new Date(blog.date).toDateString()}
        </Meta>

       

        <Content
          dangerouslySetInnerHTML={{ __html: blog.content.rendered }}
        />
      </Container>
    </BlogDetailsWrapper>
  );
};

export default BlogDetails;
